import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Box, Button, Container, TextField, Typography } from '@material-ui/core';
import { UserMutations, UserQueries } from '../models/user';
import { useMutation, useQuery } from '@apollo/client';
import { useCallback } from 'react';
import * as localforage from 'localforage';

const Login = () => {
  const navigate = useNavigate();
  const [login] = useMutation(UserMutations.login);
  const { refetch } = useQuery(UserQueries.fetchMe);

  const onSubmit = useCallback(
    async ({ email, password }) => {
      try {
        const response = await login({
          variables: { email, password },
        });
        if (response.data?.login.token) {
          await localforage.setItem('@token', response.data?.login?.token);
          await refetch();

          navigate('/app/users', { replace: true });
        }
      } catch (e) {
        console.log({ e });
      }
    },
    [login, navigate]
  );

  return (
    <>
      <Helmet>
        <title>Login | Vithoulkas App Admin</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              email: '',
              password: '',
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string()
                .email('Must be a valid email')
                .max(255)
                .required('Email is required'),
              password: Yup.string().max(255).required('Password is required'),
            })}
            onSubmit={onSubmit}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box sx={{ mb: 3 }}>
                  <Typography color="textPrimary" variant="h2">
                    Sign in
                  </Typography>
                  <Typography color="textSecondary" gutterBottom variant="body2">
                    Sign in on the internal platform
                  </Typography>
                </Box>
                <TextField
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label="Email Address"
                  margin="normal"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="email"
                  value={values.email}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="Password"
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.password}
                  variant="outlined"
                />
                <Box sx={{ py: 2 }}>
                  <Button
                    color="primary"
                    disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Sign in now
                  </Button>
                </Box>
                {/*<Typography color="textSecondary" variant="body1">*/}
                {/*  Don&apos;t have an account?{' '}*/}
                {/*  <Link component={RouterLink} to="/register" variant="h6">*/}
                {/*    Sign up*/}
                {/*  </Link>*/}
                {/*</Typography>*/}
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </>
  );
};

export default Login;
